import {Monster} from '../../generated/types';
import {monsterTypesByGender} from './monster-types-by-gender';
import {toMonsterTypeString} from './to-monster-type-string';

export function toMonsterTypeLine(monster: Monster) {
	const {size: sizes, types, subType, swarmSize, alignment: alignments} = monster;
	const firstType = types?.at(0);

	const gender = swarmSize
		? 'female'
		: types?.length > 1
		? 'plural'
		: Object.keys(monsterTypesByGender).find((gender) => monsterTypesByGender[gender].types?.includes(firstType || '')) || 'male';

	const resultSize = (sizes || []).map((size) => monsterTypesByGender[gender].sizes[size] || size).join(' или ');

	const resultType = toMonsterTypeString(types, swarmSize);

	const resultAlignments = (alignments || [])
		.map((alignment) => monsterTypesByGender[gender].alignments[alignment])
		.join(' ');

	return `${resultSize} ${resultType}${subType ? ` (${subType})` : ''}, ${resultAlignments}`;
}
